import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Link } from "react-router-dom";
import { RoleEnum } from "../../features/users/enums/role.enum";

export const NotFound = () => {
    const user = useSelector((state: RootState) => state.session.user);
    let toURL = '/cms/login';

    switch (user?.role) {
        case RoleEnum.Admin: toURL = '/cms/admin/dashboard'; break;
        case RoleEnum.CompanyAdmin: toURL = '/cms/company-admin/dashboard'; break;
        case RoleEnum.Maintainer: toURL = '/cms/maintainer/dashboard'; break;
        case RoleEnum.User: toURL = '/cms/user/dashboard'; break;
    }

    return (
        <p className="text-center">
            <strong>404</strong> - a keresett oldal nem található.<br/>
            <Link to={toURL}>Vissza a főoldalra</Link>
        </p>
    );
};